export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L1_solid_l_01_f_mask.cfdd5855.png";